(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .directive('onReadFile',['$parse', function ($parse) {
		    return {
		        restrict: 'A',
		        scope: false,
		        link: function(scope, element, attrs) {
		            element.bind('change', function(e) {
		                
		                var onFileReadFn = $parse(attrs.onReadFile);
		                var reader = new FileReader();
		                
		                reader.onload = function() {
		                    var fileContents = reader.result;
		                    // invoke parsed function on scope
		                    // special syntax for passing in data
		                    // to named parameters
		                    // in the parsed function
		                    // we are providing a value for the property 'contents'
		                    // in the scope we pass in to the function
		                    scope.$apply(function() {
		                        onFileReadFn(scope, {
		                            'contents' : fileContents
		                        });
		                    });
		                };
		                reader.readAsText(element[0].files[0]);
		            });
		        }
		    };
		}])
        .controller('PolicyDialogController', PolicyDialogController);

    
    
    
    
    PolicyDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Policy','Service','IdmCategoria','IdmStatiGenerali','AnagraficaService','SessionStorage'];

    function PolicyDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Policy, Service,IdmCategoria,IdmStatiGenerali,AnagraficaService,SessionStorage) {
        var vm = this;

        var inputChangedPromise;
        vm.clear = clear;
        vm.save = save;
        vm.switchMode = switchMode;
        vm.testMode = false;
        vm.whyPolicyIsIncorrect = null;
        vm.policyIsCorrect = null;
        vm.addService = addService;
        vm.removeService = removeService;
        vm.getCategorie = getCategorie;
        vm.getSottoCategorie = getSottoCategorie;
        vm.getStatiSpecifici = getStatiSpecifici;
        vm.addRegola = addRegola;
        vm.removeRegola = removeRegola;
        vm.addUtente = addUtente;
        vm.addNuovoUtente = addNuovoUtente;
        vm.removeUtente = removeUtente;
        vm.loadListaUtenti = loadListaUtenti;
        vm.atLeastOneService = atLeastOneService;
        
        vm.policy = entity;
        
        vm.selectUtente = selectUtente;
        vm.testPolicies = testPolicies;
        vm.typing = true;
        vm.loading = false;
        vm.services = [];
        vm.attributes = {};
        vm.user = null;
        vm.roles = [];
        vm.executions = [];
        vm.attributesSize = 0;
        
        vm.selAttrValide = false;
        
        SessionStorage.init(vm, "UR1L.testPolicy", ["selectedUser"]);
        
        $scope.$watch('vm.selectedUser', function (newValue) {
        	vm.typing = true;
            vm.services = [];
            vm.attributes = {};
            vm.user = null;
            vm.roles = [];
            vm.executions = [];
            vm.attributesSize = 0;
        });
        
        function testPolicies(){
        	vm.typing = false;
            vm.loading = true;
        	Service.testPolicy({"uid":vm.selectedUser,name:vm.policy.name,policyJS:vm.policy.policyJS,services:vm.policyServices}, function(result) {
        		console.log(result);
        		vm.services = result.services;
                vm.attributes = result.rawAttributes;
                delete vm.attributes["userPassword"];
                vm.user = result.user;
                vm.roles = result.roles;
                vm.executions = result.executions;

                vm.loading = false;
                vm.attributesSize = Object.keys(result.rawAttributes).length;
        	}, function(error) {
                vm.loading = false;
        	});
        }
        
        function selectUtente($item, $model, $label){
        	if ($item && $item.userId) {
        		vm.selectedUser = $item.userId;
        	} else {
            	vm.selectedUser = "";
        	}
        	SessionStorage.saveAll(vm, "UR1L.testPolicy", ["selectedUser"]);
        }
        
        vm.selectUid = function($item, $model, $label){
        	if ($item && $item.userId) {
        		vm.selectedUid = $item.userId;
        	} else {
            	vm.selectedUid = "";
        	}
        };
        
        //Modifica
        if(vm.policy.id!=null){
        	vm.regole = vm.policy.regole ? ( vm.policy.regole.map(function(rule) {
        		var newRule = {};
        		angular.forEach(rule, function(value, key) {
    			  this[key] = (value ? value.replace(/^\(\?i\)\\b/, "").replace(/\\b\(\?-i\)$/, "") : value);
    			}, newRule);
        		return newRule;
        	}) ) : vm.policy.regole;
        	
        	vm.policyUsers = vm.policy.utenti;
        	vm.policyServices = vm.policy.servizi;
        }
        //Nuovo
        else{
        	vm.regole = [];
        	vm.policyUsers = [];
        	vm.policyServices = [];
        }
        
        //Modalità guidata
        if(true || vm.policy.flInserimentoGuidato || vm.policy.id==null){
        	/*Elenco dei servizi*/
            Service.getAll({}, function(result){
            	vm.listaServizi = result;
            },
            function(response){
            	console.log(response);
            });
            
            /*Elenco categorie*/
            IdmCategoria.query({}, function(result){
            	vm.listaMacroCategorie = result;
            	vm.listaCategorieNonVuote = [];
            	angular.forEach(vm.listaMacroCategorie, function(mc, key) {
            		angular.forEach(mc.figli, function(cat, key) {
              		  var figli = cat.figli.filter(function(x) { return x != null && x.descrizione != null && x.descrizione != '-'})
              		  if (figli.length > 0) {
              			vm.listaCategorieNonVuote.push(cat);
              		  }
              		}, {});
        		}, {});
            },
            function(response){
            	console.log(response);
            });
            
//            /*Elenco stati generali*/
//            IdmStatiGenerali.query({}, function(result){
//            	vm.listaStatiGenerali = result;
//            	vm.listaStatiSpecifici = [];
//            	angular.forEach(vm.listaStatiGenerali, function(sg, key) {
//            		angular.forEach(sg.statiSpecifici, function(sp, key) {
//            			vm.listaStatiSpecifici.push(sp);
//              		}, {});
//        		}, {});
//            	vm.listaStatiSpecifici = vm.listaStatiSpecifici.sort().filter(function(el,i,a) {
//                    return (i==a.indexOf(el));
//                });
//            },
//            function(response){
//            	console.log(response);
//            });
            
            /*Elenco macro stati*/
            IdmStatiGenerali.macroStati({}, function(result){
            	vm.listaMacroStati = result;
            },
            function(response){
            	console.log(response);
            });
            
            /*Elenco stati*/
            IdmStatiGenerali.allStati({}, function(result){
            	vm.listaStati = result.sort();
            },
            function(response){
            	console.log(response);
            });
            
            /*Elenco ruoli*/
            IdmStatiGenerali.ruoli({}, function(result){
            	vm.listaRuoli = result;
            },
            function(response){
            	console.log(response);
            });
        }
        
        
        
        

        
        
       
        
        /**** Editor di testo ****/
        $scope.aceLoaded = function(_editor){
        	console.log(vm.policy.policyJS);
        	if(vm.policy.policyJS!=null)
        		$scope.verificaPolicy();
//			// Editor part
//			var _session = _editor.getSession();
//			var _renderer = _editor.renderer;
//			// Options
//			_renderer.setShowGutter(true);
//			_session.setUseWrapMode(true);
//			_session.setMode('ace/mode/javascript');
//			_session.setUndoManager(new ace.UndoManager());
//			_editor.setHighlightActiveLine(true);
//			_editor.setHighlightSelectedWord(true);
//			_editor.setShowPrintMargin(false);
//			_editor.setTheme('ace/theme/tomorrow');
//			_editor.on("change", $scope.aceChanged);

		};
		
		$scope.aceChanged = function(){
//			if(inputChangedPromise){
//		        $timeout.cancel(inputChangedPromise);
//		    }
//		    inputChangedPromise = $timeout($scope.verificaPolicy,1000);
			
		};
		
		$scope.verificaPolicy = function() {
			Policy.verify(vm.policy, function(response){
				if(response.code===200){
					 vm.policyIsCorrect = true;
					 vm.whyPolicyIsIncorrect = null;
				}
				else{
					vm.policyIsCorrect = false;
					vm.whyPolicyIsIncorrect = response.message;
				}
			},
			function(response){
				vm.policyIsCorrect = false;
				vm.whyPolicyIsIncorrect = response.data.description;
			});
	    };
	    

		$scope.displayFileContents = function(contents) {
			vm.policy.policyXACML = contents;
	    };

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            
            var obj = {
        		servizi: vm.policyServices,
        		utenti: vm.policyUsers,
        		regole: vm.regole,
        		name: vm.policy.name,
        		description: vm.policy.description,
        		policyJS: vm.policy.policyJS,
        		priority: vm.policy.priority,
        		flInserimentoGuidato: vm.policy.flInserimentoGuidato,
        		id: vm.policy.id,
        		isActive: vm.policy.isActive
        	};
            
        	if (vm.policy.id !== null) {
        		Policy.update(obj, onSaveSuccess, onSaveError);
            } else {
            	Policy.create(obj, onSaveSuccess, onSaveError);
            }
            
//            //Policy inserita in maniera testuale
//            if(!vm.policy.flInserimentoGuidato){
//            	if (vm.policy.id !== null) {
//            		Policy.update(obj, onSaveSuccess, onSaveError);
//                } else {
//                	Policy.save(obj, onSaveSuccess, onSaveError);
//                }
//            }
//            //Policy inserita in maniera guidata
//            else{
//            	if(vm.currentMacroCat!=null || vm.currentStatoGenerale!=null){
//                	addRegola();
//                }
//            	if (vm.policy.id !== null)
//            		Policy.update(obj, onSaveSuccess, onSaveError);
//            	else
//            		Policy.create(obj, onSaveSuccess, onSaveError);
//            }
            
            
            
        }

        function onSaveSuccess (result) {
            $scope.$emit('uniromaLandingApp:policyUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
            $("div.modal").scrollTop(0);
        }
        
        //Cambia da "inserimento manuale" a "inserimento guidato" (e viceversa)
        function switchMode(value){
        	vm.testMode = value;
        }
        
        //Aggiunge un servizio, chiamata all'onClick sull'autocompletamento
        function addService($item, $model, $label){
        	if(vm.policyServices == null)
        		vm.policyServices = [];
        	
        	var index = vm.policyServices.indexOf($item.code);
        	if(index==-1)
        		vm.policyServices.push($item.code);
        	vm.selectedService = null;
        }
        //Rimuove il servizio selezionato
        function removeService(servizio){
        	var index = vm.policyServices.indexOf(servizio);
        	vm.policyServices.splice(index, 1); 
        	
        }
        //Recupera l'elenco delle categorie, in base alla macroCategoria selezionata
        function getCategorie(){
        	if(vm.currentMacroCat!=null)
        		vm.listaCategorie = vm.currentMacroCat.figli;
        	else
        		vm.listaCategorie = [];

        }
        //Recupera l'elenco delle sottoCategorie, in base alla categoria selezionata
        function getSottoCategorie(){
        	if(vm.currentCategoria!=null)
        		vm.listaSottoCategorie = vm.currentCategoria.figli;
        	else
        		vm.listaSottoCategorie = [];
        }
        //Recupera l'elenco degli stati specifici, in base allo stato generale selezionato
        function getStatiSpecifici(){
        	if(vm.currentStatoGenerale!=null)
        		vm.listaStatiSpecifici = vm.currentStatoGenerale.statiSpecifici;
        	else
        		vm.listaStatiSpecifici = [];
        }
        
        //Aggiunge la regola
        function addRegola(){
        	var object = {};
        	if(vm.currentMacroCat!=null)
        		object.macroCategoria = vm.currentMacroCat.descrizione;
        	if(vm.currentCategoria!=null)
        		object.categoria = vm.currentCategoria.descrizione;
        	if(vm.currentSottoCat!=null)
        		object.sottoCategoria = vm.currentSottoCat.descrizione;
        	if(vm.currentStatoGenerale!=null)
        		object.statoGenerale = vm.currentStatoGenerale.statoGenerale;
        	
        	object.statoSpecifico = vm.currentStatoSpecifico;
        	
        	if(vm.regole.indexOf(object)==-1)
        		vm.regole.push(object);
        	
        	//Pulisco i campi
        	vm.currentMacroCat = null;
        	vm.currentCategoria = null;
        	vm.currentSottoCat = null;
        	vm.currentStatoGenerale = null;
        	vm.currentStatoSpecifico = null;
        }
        //Rimuove la regola selezionata
        function removeRegola(regola){
        	var index = vm.regole.indexOf(regola);
        	vm.regole.splice(index, 1); 
        }
        //Aggiunge l'utente selezionato dall'autocompletamento
        function addUtente($item, $model, $label){
        	if(vm.policyUsers == null)
        		vm.policyUsers = [];
        	
        	var index = vm.policyUsers.indexOf($item);
        	if(index==-1)
        		vm.policyUsers.push($item);
        	vm.selectedUser = null;
        }
        //Aggiunge un nuovo utente, se non è stato trovato dall'autocompletamento
        function addNuovoUtente(){
        	if(vm.selectedUser!=null && vm.selectedUser!=""){
		    	if(vm.policyUsers == null)
		    		vm.policyUsers = [];
    	
		    	var utente = {
		    		userId: vm.selectedUser,
		    		nome: null,
		    		cognome: null
		    	};
		    	var index = vm.policyUsers.indexOf(utente);
		    	if(index==-1)
		    		vm.policyUsers.push(utente);
		    	vm.selectedUser = null;
        	}
        }
        //Rimuove l'utente selezionato
        function removeUtente(utente){
        	var index = vm.policyUsers.indexOf(utente);
        	vm.policyUsers.splice(index, 1); 
        	
        }
        
        function loadListaUtenti(testo){
        	
        	if(testo.length>=5){
	            return AnagraficaService.anagrafiche.get({filtroTesto:testo}).$promise
        	}
        	else{
        		return [];
        	}

        }
        
        function atLeastOneService(){
        	if((true || vm.policy.flInserimentoGuidato) && (vm.policyServices==null || vm.policyServices.length==0))
        		return false;
        	return true;
        }
        
        function toStringAttributeOperation(selAttr, selOperation, value) {
        	var toAdd = '';
        	if (selOperation == '*=') {
				toAdd = selAttr + '.match(/' + value + '/i)';
			} else {
				toAdd = selAttr + selOperation + '\'' + value + '\'';
			}
        	return toAdd;
        }
        
        vm.validate = function() {
        	switch(vm.selAttr){
    		case 'user.uid': 
    			vm.selAttrValide = vm.selOperation && vm.selOperation != '' && vm.selectedUid && vm.selectedUid != '';
    			break;
    		case 'user.nome': 
    		case 'user.cognome': 
    		case 'rawAttributes.codiceFiscale': 
    		case 'rawAttributes.matricolaStudente': 
    		case 'rawAttributes.email': 
    			vm.selAttrValide = vm.selOperation && vm.selOperation != '' && vm.testoLibero && vm.testoLibero != '';
    			break;
    		case 'role.ruolo': 
    			vm.selAttrValide = vm.selOperation && vm.selOperation != '' && vm.currentRuolo && vm.currentRuolo != '';
    			break;
    		case 'role.macroCategoria': 
    			vm.selAttrValide = vm.selOperation && vm.selOperation != '' && vm.currentMacroCat && vm.currentMacroCat.descrizione && vm.currentMacroCat.descrizione != '';
    			break;
    		case 'role.categoria': 
    			vm.selAttrValide = vm.selOperation && vm.selOperation != '' && vm.currentCat && vm.currentCat != '';
    			break;
    		case 'role.sottoCategoria': 
    			vm.selAttrValide = vm.selOperation && vm.selOperation != '' && vm.currentSottoCat && vm.currentSottoCat != '';
    			break;
    		case 'user.statoAggregato': 
    		case 'role.macroStato': 
    			vm.selAttrValide = vm.selOperation && vm.selOperation != '' && vm.currentMacroStato && vm.currentMacroStato.macroStato && vm.currentMacroStato.macroStato != '';
    			break;
    		case 'role.statoSpecifico': 
    			vm.selAttrValide = vm.selOperation && vm.selOperation != '' && vm.currentStatoSpecifico && vm.currentStatoSpecifico != '';
    			break;
    		case 'role.decorrenza': 
    			vm.selAttrValide = vm.selOperation && vm.selOperation != '' && 
    			(
    				(vm.currentDecorrenza && vm.currentDecorrenza != '' && vm.selOperation.indexOf('NMesi') < 0) 
    				|| (vm.numeroLibero && vm.numeroLibero != '' && vm.selOperation.indexOf('NMesi') >= 0)
    			);
    			break;
    		case 'role.giorniDaDecorrenza': 
    			vm.selAttrValide = vm.selOperation && vm.selOperation != '' && vm.numeroLibero && vm.numeroLibero != '';
    			break;
	    		default: vm.selAttrValide = false; break;
	    	}
    	}
        
        vm.addToPolicy = function() {
        	var toAdd = '';
        	switch(vm.selAttr){
    		case 'user.uid': 
    			toAdd = toStringAttributeOperation(vm.selAttr, vm.selOperation, vm.selectedUid);
    			break;
    		case 'user.nome': 
    		case 'user.cognome': 
    		case 'rawAttributes.codiceFiscale': 
    		case 'rawAttributes.matricolaStudente': 
    		case 'rawAttributes.email': 
    			toAdd = toStringAttributeOperation(vm.selAttr, vm.selOperation, vm.testoLibero);
    			break;
    		case 'role.ruolo': 
    			toAdd = toStringAttributeOperation(vm.selAttr, vm.selOperation, vm.currentRuolo);
    			break;
    		case 'role.macroCategoria': 
    			toAdd = toStringAttributeOperation(vm.selAttr, vm.selOperation, vm.currentMacroCat.descrizione);
    			break;
    		case 'role.categoria': 
    			toAdd = toStringAttributeOperation(vm.selAttr, vm.selOperation, vm.currentCat);
    			break;
    		case 'role.sottoCategoria': 
    			toAdd = toStringAttributeOperation(vm.selAttr, vm.selOperation, vm.currentSottoCat);
    			break;
    		case 'user.statoAggregato': 
    		case 'role.macroStato': 
    			toAdd = toStringAttributeOperation(vm.selAttr, vm.selOperation, vm.currentMacroStato.macroStato);
    			break;
    		case 'role.statoSpecifico': 
    			toAdd = toStringAttributeOperation(vm.selAttr, vm.selOperation, vm.currentStatoSpecifico);
    			break;
    		case 'role.decorrenza': 
    			if (vm.selOperation.indexOf('NMesi') < 0) {
    				toAdd = 'new Date(Date.parse(role.decorrenza))'+((vm.selOperation == '==' || vm.selOperation == '!=')?'.getTime()':'')
    				+ vm.selOperation 
    				+ 'new Date(Date.parse(\''+vm.currentDecorrenza.toISOString()+'\'))'+((vm.selOperation == '==' || vm.selOperation == '!=')?'.getTime()':'');
    			} else if (vm.selOperation == 'entroNMesi') {
    				toAdd = 'new Date(Date.parse(role.decorrenza))>=('
    				+ 'new Date(new Date().setMonth(new Date().getMonth()' + (vm.numeroLibero >= 0 ? '-'+vm.numeroLibero : '+'+(0-vm.numeroLibero)) + ')))';
    			} else if (vm.selOperation == 'traNMesi') {
    				toAdd = 'new Date(Date.parse(role.decorrenza))<=('
    				+ 'new Date(new Date().setMonth(new Date().getMonth()' + (vm.numeroLibero >= 0 ? '-'+vm.numeroLibero : '+'+(0-vm.numeroLibero)) + ')))';
    			}
    			
    			break;
    		case 'role.giorniDaDecorrenza': 
    			toAdd = vm.selAttr + vm.selOperation + vm.numeroLibero;
    			break;

	    		default: vm.selAttrValide = false; break;
	    	}
        	if (toAdd != '') {
        		vm.policy.policyJS = ((vm.policy.policyJS && vm.policy.policyJS.length > 0) ? vm.policy.policyJS + ' && (' : '(') + toAdd + ')';
        	}
    	}
        
        vm.addElencoToPolicy = function() {
        	var arr = vm.currentElenco.split(/\r?\n/);
        	var toAdd = '';
        	angular.forEach(arr, function(str, key) {
        		str = str.trim();
        		if (str != '') {
        			if (toAdd == '') {
        				toAdd = '[';
        			} else {
        				toAdd += ',';
        			}
        			toAdd += '\''+ str +'\'';
        		}
    		}, {});
        	if (toAdd != '') {
        		toAdd += '].indexOf(' + vm.selAttr + ')>=0';
        		vm.policy.policyJS = ((vm.policy.policyJS && vm.policy.policyJS.length > 0) ? vm.policy.policyJS + ' && (' : '(') + toAdd + ')';
        	}
        }
        
        vm.validate();
        
        $scope.editorOptions = "{ lineNumbers: true, mode: 'javascript', onLoad : aceLoaded }"

    }
})();
